module.exports = __webpack_public_path__ + "c89a0f332a46f47195ae982ef8532587.svg";